var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Card",
        [
          _vm.innerSpin
            ? _c("Spin", { attrs: { size: "large", fix: "" } })
            : _vm._e(),
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.mainTable.sarchCardShow
                ? _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c("search-card", {
                            attrs: {
                              form: _vm.mainTable.searchForm,
                              "table-load-event": _vm.getPromotionTableRecords,
                              "table-search": _vm.mainTable.tableSearch,
                              colSpan: 4,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "global-tool-bar" }, [
                  _c("div", { staticClass: "left-bar" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v("客户优惠管理"),
                    ]),
                  ]),
                  _c("div", { staticClass: "right-bar" }, [
                    _vm.$checkAccessArray(["B"])
                      ? _c(
                          "div",
                          [
                            _c(
                              "Button",
                              {
                                staticClass: "btns",
                                attrs: {
                                  size: "small",
                                  shape: "circle",
                                  icon: "md-arrow-down",
                                },
                                on: { click: _vm.onExport },
                              },
                              [_vm._v("导出")]
                            ),
                            _c(
                              "Button",
                              {
                                staticClass: "btns",
                                attrs: {
                                  size: "small",
                                  shape: "circle",
                                  type: "success",
                                  icon: "ios-add-circle-outline",
                                },
                                on: { click: _vm.onCreate },
                              },
                              [_vm._v("新增")]
                            ),
                            _c(
                              "Button",
                              {
                                staticClass: "btns",
                                attrs: {
                                  size: "small",
                                  shape: "circle",
                                  type: "warning",
                                  icon: "ios-add-circle-outline",
                                },
                                on: { click: _vm.onBatchCreate },
                              },
                              [_vm._v("批量新增")]
                            ),
                            _c(
                              "Button",
                              {
                                staticClass: "btns",
                                attrs: {
                                  size: "small",
                                  shape: "circle",
                                  type: "info",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onActive(1)
                                  },
                                },
                              },
                              [_vm._v("启用")]
                            ),
                            _c(
                              "Button",
                              {
                                staticClass: "btns",
                                attrs: {
                                  size: "small",
                                  shape: "circle",
                                  type: "error",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onActive(0)
                                  },
                                },
                              },
                              [_vm._v("停用")]
                            ),
                            _c(
                              "Button",
                              {
                                staticClass: "btns",
                                attrs: {
                                  size: "small",
                                  shape: "circle",
                                  type: "info",
                                  ghost: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onPublic(1)
                                  },
                                },
                              },
                              [_vm._v("公开")]
                            ),
                            _c(
                              "Button",
                              {
                                staticClass: "btns",
                                attrs: {
                                  size: "small",
                                  shape: "circle",
                                  type: "error",
                                  ghost: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onPublic(0)
                                  },
                                },
                              },
                              [_vm._v("不公开")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      [
                        _c(
                          "Button",
                          {
                            staticClass: "btns",
                            attrs: {
                              type: "primary",
                              size: "small",
                              shape: "circle",
                              icon: "ios-search",
                            },
                            on: {
                              click: function ($event) {
                                _vm.mainTable.sarchCardShow =
                                  !_vm.mainTable.sarchCardShow
                              },
                            },
                          },
                          [_vm._v("搜索")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("stand-pagination-table", {
                    ref: "promotionTable",
                    attrs: {
                      columns: _vm.mainTable.columns,
                      data: _vm.mainTable.data,
                      loading: _vm.mainTable.loading,
                      "table-search": _vm.mainTable.tableSearch,
                      "table-load-event": _vm.getPromotionTableRecords,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: { title: "客户优惠信息", width: "600" },
          model: {
            value: _vm.promotionForm.show,
            callback: function ($$v) {
              _vm.$set(_vm.promotionForm, "show", $$v)
            },
            expression: "promotionForm.show",
          },
        },
        [
          _c("Loading", { attrs: { isLoading: _vm.saveLoading } }),
          _c(
            "Form",
            {
              ref: "promotionForm",
              attrs: { model: _vm.promotionForm, "label-position": "top" },
            },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _vm.promotionForm.type === "single"
                    ? _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { label: "客户信息" } },
                            [
                              _c(
                                "Select",
                                {
                                  attrs: { filterable: "" },
                                  model: {
                                    value: _vm.promotionForm.promotionUserUuid,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.promotionForm,
                                        "promotionUserUuid",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "promotionForm.promotionUserUuid",
                                  },
                                },
                                _vm._l(_vm.userList, function (item) {
                                  return _c(
                                    "Option",
                                    {
                                      key: item.userExternalCustomerLoginUuid,
                                      attrs: {
                                        value:
                                          item.userExternalCustomerLoginUuid,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.userName +
                                            "-" +
                                            item.userExternalCustomerName +
                                            "-" +
                                            item.userExternalCustomerPhone
                                        )
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { label: "客户信息" } },
                            [
                              _c(
                                "Select",
                                {
                                  attrs: { filterable: "", multiple: "" },
                                  model: {
                                    value: _vm.promotionForm.promotionUserUuids,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.promotionForm,
                                        "promotionUserUuids",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "promotionForm.promotionUserUuids",
                                  },
                                },
                                _vm._l(_vm.userList, function (item) {
                                  return _c(
                                    "Option",
                                    {
                                      key: item.userExternalCustomerLoginUuid,
                                      attrs: {
                                        value:
                                          item.userExternalCustomerLoginUuid,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.userName +
                                            "-" +
                                            item.userExternalCustomerName +
                                            "-" +
                                            item.userExternalCustomerPhone
                                        )
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "是否启用" } },
                        [
                          _c(
                            "RadioGroup",
                            {
                              model: {
                                value: _vm.promotionForm.promotionEnable,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.promotionForm,
                                    "promotionEnable",
                                    $$v
                                  )
                                },
                                expression: "promotionForm.promotionEnable",
                              },
                            },
                            [
                              _c("Radio", { attrs: { label: 1 } }, [
                                _vm._v("启用"),
                              ]),
                              _c("Radio", { attrs: { label: 0 } }, [
                                _vm._v("停用"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "是否公开" } },
                        [
                          _c(
                            "RadioGroup",
                            {
                              model: {
                                value: _vm.promotionForm.promotionPublic,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.promotionForm,
                                    "promotionPublic",
                                    $$v
                                  )
                                },
                                expression: "promotionForm.promotionPublic",
                              },
                            },
                            [
                              _c("Radio", { attrs: { label: 1 } }, [
                                _vm._v("公开"),
                              ]),
                              _c("Radio", { attrs: { label: 0 } }, [
                                _vm._v("不公开"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "折扣比例(如九折=0.9)" } },
                        [
                          _c("InputNumber", {
                            staticStyle: { width: "100%" },
                            attrs: { min: 0, "active-change": false },
                            model: {
                              value: _vm.promotionForm.promotionQuantityDisount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.promotionForm,
                                  "promotionQuantityDisount",
                                  $$v
                                )
                              },
                              expression:
                                "promotionForm.promotionQuantityDisount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "单价优惠(元)" } },
                        [
                          _c("InputNumber", {
                            staticStyle: { width: "100%" },
                            attrs: { min: 0, "active-change": false },
                            model: {
                              value: _vm.promotionForm.promotionValudeDiscount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.promotionForm,
                                  "promotionValudeDiscount",
                                  $$v
                                )
                              },
                              expression:
                                "promotionForm.promotionValudeDiscount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("Row", { attrs: { gutter: 16 } }),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "总价优惠(元)" } },
                        [
                          _c("InputNumber", {
                            staticStyle: { width: "100%" },
                            attrs: { min: 0, "active-change": false },
                            model: {
                              value: _vm.promotionForm.promotionDepositDiscount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.promotionForm,
                                  "promotionDepositDiscount",
                                  $$v
                                )
                              },
                              expression:
                                "promotionForm.promotionDepositDiscount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                { attrs: { type: "primary" }, on: { click: _vm.onSave } },
                [_vm._v("确认")]
              ),
              _c(
                "Button",
                { attrs: { type: "error" }, on: { click: _vm.onCancel } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }